import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { TimePicker } from "antd";

dayjs.extend(customParseFormat);

// Answers are stored as 24-hour "HH.mm" (e.g. "14.30"); older data may use "HH:mm".
const STORED_FORMAT = "HH.mm";

const parseStored = (value) => {
	if (!value || typeof value !== "string") {
		return null;
	}
	const parsed = dayjs(value.replace(".", ":"), "HH:mm");
	return parsed.isValid() ? parsed : null;
};

/**
 * 12-hour time picker with AM/PM, used for TIME questions.
 *
 * This is the only file that knows which picker library is used, so swapping
 * the library later only means changing this component. `value` and the value
 * passed to `onChange` are always in the stored "HH.mm" format.
 */
export default function TimeField({ value, onChange, disabled }) {
	return (
		<TimePicker
			style={{ width: "100%" }}
			use12Hours
			format="hh:mm A"
			allowClear={false}
			needConfirm={false}
			value={parseStored(value)}
			disabled={disabled}
			onChange={(time) => {
				if (!time || !time.isValid()) {
					return;
				}
				onChange(time.format(STORED_FORMAT));
			}}
		/>
	);
}

TimeField.propTypes = {
	value: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};
